import { render, staticRenderFns } from "./AuthorCard.vue?vue&type=template&id=6fd5852d&scoped=true&"
import script from "./AuthorCard.vue?vue&type=script&lang=js&"
export * from "./AuthorCard.vue?vue&type=script&lang=js&"
import style0 from "./AuthorCard.vue?vue&type=style&index=0&id=6fd5852d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd5852d",
  null
  
)

export default component.exports